import { currencyOptions } from './currencyOptions';

/**
 * Get the currency symbol for a given currency code (case-insensitive).
 * @param {string} code - The currency code (e.g. 'usd', 'inr', 'USD', 'INR')
 * @returns {string} The currency symbol, or the code itself if not found.
 */
export function getCurrencySymbol(code) {
  if (!code) return '';
  const upperCode = code.toUpperCase();
  const found = currencyOptions.find(opt => opt.value === upperCode);
  return found ? found.symbol : code;
}
